import React, {Dispatch, SetStateAction, useEffect, useState} from "react";
import {Box, Grid, Stack, Switch, Typography} from "@mui/material";
// @ts-ignore
import logo from "../../assets/img/addnewuser.png";
import {styled} from "@mui/material/styles";
import Button from "@mui/material/Button";
import CircularProgress from "@mui/material/CircularProgress";
import AdapterDateFns from "@mui/lab/AdapterDateFns";
import DesktopDatePicker from "@mui/lab/DesktopDatePicker";
import LocalizationProvider from "@mui/lab/LocalizationProvider";
import services from "../../services";


const GreenSwitch = styled(Switch)(({ theme }) => ({
    '& .MuiSwitch-switchBase.Mui-checked': {
        color: "#089BAB",
        '&:hover': {
            backgroundColor: "none",
        },
    },
    '& .MuiSwitch-switchBase.Mui-checked + .MuiSwitch-track': {
        backgroundColor: "#089BAB",
    },
}));


interface NewUser {
    first_name: string,
    last_name: string,
    email: string,
    dob: string,
    password: string,
    confirm_password? : string
}

interface AddNewUser {
    handleClose : ()=>void,
    refreshUsers:() =>void
}

export const AddNewUser = ({handleClose,refreshUsers} : AddNewUser) =>{

    const [user,setUser] = useState<NewUser>({
        first_name: "",
        last_name: "",
        email: "",
        dob: "",
        password: "",
        confirm_password : "",
    })
    const [wasOpened, setWasOpened] = useState<boolean>(false);
    const [validationDate,setValidationDate] = useState({message: '',error:false})

    const [validationErrors,setValidationErrors] = useState<NewUser>({
        first_name: "",
        last_name: "",
        email: "",
        dob: "",
        password: "",
    })

    const [backEndErrors,setBackEndErrors] = useState([])

    const [passwordMatched,setPasswordMatched] = useState<boolean | null>(null)

    const [loader,setLoader] = useState<boolean>(false)

    const handleInputChange = (e : React.ChangeEvent<HTMLInputElement>) =>{
        setUser(prevState => {
            return { ...prevState, [e.target.name] : e.target.value }
        })
        setValidationErrors(prevState => {
            return {...prevState,[e.target.name] : ""}
        })
    }

    const handleAddUser = () =>{
        for (const u in user) {
            // @ts-ignore
            if(!user[u].length){
                setValidationErrors(prevState => {
                    return {...prevState,[u] : "2px solid red"}
                })
            }
        }
        if(!Object.values(user).filter(i =>i.length===0).length){
            setBackEndErrors([])
            setLoader(true)
            services
                .AddUser({...user})
                .then(response=>{
                    setLoader(false)
                    handleClose()
                    refreshUsers()
                })
                .catch(error=>{
                    setLoader(false)
                    if(error.response.data.errors){
                        setBackEndErrors(error.response.data.errors)
                    }
                })
        }
    }

    const getBackEndError = (param : string) =>{
        let error : any = backEndErrors.filter((e:any) => e.param === param)

        if(error.length>0) {
            return error[0].msg
        }
    }


    const OnDateChange = (newValue:Date) => {

        if(wasOpened){
            setUser((prevState : NewUser) => {
                return {...prevState,dob:newValue.toISOString().split('T')[0]!}
            })
            setValidationErrors(prevState => {
                return {...prevState,dob : ""}
            })
        }
        else{
            var timestamp = Date.parse(newValue !==null ? newValue.toString() : '');

            if(newValue > new Date()){
                setValidationDate({message: 'red',error:true})
                return false
            }

            if (isNaN(timestamp) == false) {
                setValidationDate({message: '',error:false})
                let date = new Date(newValue.setDate(newValue.getDate() + 1))
                setUser(prevState => {
                    return {...prevState,dob:date.toISOString().split('T')[0]!}
                })
                setValidationErrors(prevState => {
                    return {...prevState,dob : ""}
                })

            }
        }
    }

    useEffect(()=>{
        if(user.password.length>0){
            if(user.password === user.confirm_password)
                setPasswordMatched(true)
            else
                setPasswordMatched(false)
        }

    },[user.confirm_password])

    return (
        <Box sx={{ flexGrow: 1,width:900}}>
            <Grid
                container
                direction="row"
                justifyContent="center"
                spacing={3}
            >
                <Grid item xs={6}>
                    <Stack
                        direction="column"
                        justifyContent="flex-start"
                        spacing={1}
                    >
                        <Typography fontSize={32} color={"#089BAB"}>
                            Add new user:
                        </Typography>

                        <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                            FIRST NAME
                        </Typography>
                        <input value={user.first_name} style={{border:validationErrors.first_name}} placeholder={"enter first name"} className={"edit-profile-inputs"} name={"first_name"} onChange={handleInputChange} />

                        <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                            LAST NAME
                        </Typography>
                        <input value={user.last_name} style={{border:validationErrors.last_name}} placeholder={"enter last name"} className={"edit-profile-inputs"} name={"last_name"} onChange={handleInputChange} />

                        <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                            DATE OF BIRTH
                        </Typography>
                        <LocalizationProvider dateAdapter={AdapterDateFns}>
                            <DesktopDatePicker
                                label="Custom input"
                                value={user.dob}
                                maxDate={new Date()}
                                onChange={(newValue) => {
                                    OnDateChange(newValue!)
                                }}
                                // onError={()=>console.log("error")}
                                autoFocus={true}
                                onOpen={()=>setWasOpened(true)}
                                onClose={()=>setWasOpened(false)}
                                inputFormat={"dd/MM/yyyy"}
                                renderInput={({ inputRef, inputProps, InputProps }) => (
                                    <Box sx={{
                                        display: 'flex',
                                        alignItems: 'center',
                                        background:"#FFFFFF",
                                        padding:"0px 10px",
                                        borderRadius:"7px",
                                        height:"40px",
                                        border:validationDate.error || validationErrors.dob ? "2px solid red" : "2px solid #D8DAE5",
                                        justifyContent:"space-between"
                                    }}>
                                        <input ref={inputRef} {...inputProps} style={{border:"none"}} />
                                        {InputProps?.endAdornment}
                                    </Box>
                                )}
                            />
                        </LocalizationProvider>

                        <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                            EMAIL
                        </Typography>
                        <input value={user.email} placeholder={"enter email address"} style={{border:validationErrors.email}} className={"edit-profile-inputs"} name={"email"} onChange={handleInputChange} />
                        {
                            backEndErrors.length>0?
                                <Typography fontSize={12} color={"red"}>
                                    {getBackEndError('email')}
                                </Typography>:''
                        }

                        <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                            Password
                        </Typography>
                        <input value={user.password} placeholder={"enter password"} style={{border:validationErrors.password}} type={"password"} className={"edit-profile-inputs"} name={"password"} onChange={handleInputChange} />
                        {
                            backEndErrors.length>0?
                                <Typography fontSize={12} color={"red"}>
                                    {getBackEndError('password')}
                                </Typography>:''
                        }



                        <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                            CONFIRM PASSWORD
                        </Typography>
                        <input value={user.confirm_password} placeholder={"re-enter password"}
                               style={{
                                   border: passwordMatched === null ? "" : passwordMatched?"2px solid green" : !passwordMatched ? "2px solid red" : ""
                               }}
                               type={"password"} className={"edit-profile-inputs"} name={"confirm_password"} onChange={handleInputChange} />

                    </Stack>
                </Grid>

                <Grid item xs={6}>
                    <Stack
                        direction="column"
                        justifyContent="flex-start"
                        alignItems="center"
                        spacing={4}
                        marginTop={2}
                    >
                        <div className = "circular--portrait-addnewuser">
                            <img src={"http://pkdservers.com/RPM/api/Content/Images/default.png"} />
                        </div>
                        {/*<Typography fontSize={14} color={"#089BAB"} sx={{textDecoration:'underline'}}>*/}
                        {/*    Upload photo*/}
                        {/*</Typography>*/}

                        <Stack width={"100%"} spacing={-1}>
                            <Typography color={"#081735"} fontSize={18} fontWeight={700}>
                                EMAIL ALERTS
                            </Typography>
                            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                                <Typography fontSize={14} fontWeight={400} color={"#081735"} >
                                    ON NEW MEASURMENTS
                                </Typography>
                                <GreenSwitch
                                    // checked={user?.notificationOnNewMeasurements}
                                    name={"notificationOnNewMeasurements"}
                                    // onChange={(e)=>setSlider(!user?.notificationOnNewMeasurements,e.target.name)}
                                />
                            </Stack>

                            <Stack direction={"row"} alignItems={"center"} justifyContent={"space-between"}>
                                <Typography fontSize={14} fontWeight={400} color={"#081735"}>
                                    ON ABNORMAL VALUES
                                </Typography>
                                <GreenSwitch
                                    // checked={user?.notificationOnAbnormalValues}
                                    name={"notificationOnAbnormalValues"}
                                    // onChange={(e)=>setSlider(!user?.notificationOnAbnormalValues,e.target.name)}
                                />
                            </Stack>
                        </Stack>
                        <Grid item width={"100%"} display={"flex"} justifyContent={"flex-end"}>
                            <Button
                                onClick={()=>{handleClose()}}
                                variant="outlined"
                                sx={{
                                    borderRadius:"7px",
                                    textTransform:"none",
                                    color:"#8F95B2",
                                    fontWeight:700,
                                    boxShadow:"none",
                                    padding:1,
                                    fontSize : "16px",
                                    border:"1px solid #8F95B2"
                                }}>CANCEL</Button>
                            <Button
                                onClick={()=>{handleAddUser()}}
                                variant="contained"
                                sx={{
                                    borderRadius:"7px",
                                    background:"#089BAB",
                                    textTransform:"none",
                                    color:"#F9FAFC",
                                    fontWeight:700,
                                    boxShadow:"none",
                                    padding:1,
                                    fontSize : "16px",
                                    marginLeft:"10px",
                                    width:100
                                }}>SAVE
                                <CircularProgress sx={{position:"relative",left:"10px",color:"#FFFFFF",display:loader?" ":"none"}} size={25} thickness={6}/>
                            </Button>
                        </Grid>
                    </Stack>
                </Grid>
            </Grid>
        </Box>
    )
}